import { render, staticRenderFns } from "./exhibition-product-add.vue?vue&type=template&id=fa7030c2&scoped=true&"
import script from "./exhibition-product-add.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-add.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exhibition-product-add.vue?vue&type=style&index=1&id=fa7030c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7030c2",
  null
  
)

export default component.exports